import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "h5-responsive strong p-0 m-0 fc-white d-inline-block" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.isLogin ? `Moin ${_ctx.firstName}!` : 'Menü'), 1));
}
